import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';
import { baseReducer as BaseReducer } from '../../store/core/base-reducer';
import * as Actions from './mark-as-shipped.actions';

const initialState = {
  orderBatches: [],
  shipmentBatches: [],
};

const actionHandlerMap = {
  [Actions.MARK_SHIPPED_SUCCESS]: (state, action) => {
    const batchIds = get(action, 'response.batchIds', emptyArray);
    return {
      ...state,
      orderBatches: state.orderBatches.concat(batchIds),
    };
  },
  [Actions.CLEAR_BATCH_FROM_ORDERS]: (state, action) => {
    const batchId = get(action, 'batchId');
    const { orderBatches } = state;
    const orderIdx = orderBatches.indexOf(batchId);
    if (orderIdx > -1) {
      return {
        ...state,
        orderBatches: [...state.orderBatches.slice(0, orderIdx), ...state.orderBatches.slice(orderIdx + 1)],
      };
    }
    return state;
  },
  [Actions.CLEAR_BATCH_FROM_SHIPMENTS]: (state, action) => {
    const batchId = get(action, 'batchId');
    const { shipmentBatches } = state;
    const shipmentIdx = shipmentBatches.indexOf(batchId);
    if (shipmentIdx > -1) {
      return {
        ...state,
        shipmentBatches: [...state.shipmentBatches.slice(0, shipmentIdx), ...state.shipmentBatches.slice(shipmentIdx + 1)],
      };
    }
    return state;
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './mark-as-shipped.reducer.metadata';
